import * as PRIVILEGE from '@shared/constants/privilege'

// 权限版本 仅适用于展示性判断 如涉及权限需根据权限编码判断
export enum PrivilegeVersion {
  Smart = 13,
  Pro = 14,
  Lite = 15,
}

// 邮件类型
export const MAIL_TYPE = {
  UN_KNOW: '0',
  RECEIVED: '1',
  SENT: '2',
}

// 账号类型
export enum AccountType {
  Member = 0, // 普通成员（子账号）
  DepartmentManagement = 1, // 部门管理员（子账号）
  SuperManagement = 2, // 超级管理员（主账号）
}
